import { Inject, Injectable } from '@angular/core';
import { POINTS_TRANSACTION_DIGITS_INFO } from '@rd/core/tokens/rd-lib.token';
import {
  PointsStatementTransactionType,
  PointsTransaction,
  PointsTransactionCategory,
} from '@rd/types';
import { RoundMode } from '@rd/types/round-mode.type';
import { PointsNumberService } from '../points-number/points-number.service';

@Injectable({
  providedIn: 'root',
})
export class PointsTransactionService {
  constructor(
    @Inject(POINTS_TRANSACTION_DIGITS_INFO) protected digitsInfo: string,
    protected pointsNumberService: PointsNumberService,
  ) {}

  formatPointsTransaction(
    pointsTransaction: PointsTransaction,
    digitsInfo: string = this.digitsInfo,
    roundDigits: number = 0,
    roundMode: RoundMode = RoundMode.NONE,
  ): string {
    const { category, amount } = pointsTransaction;

    if (amount === 0) {
      return this.pointsNumberService.roundNumber(0, digitsInfo);
    } else {
      const CATEGORIES_WITH_POSITIVE_AMOUNT = [
        PointsTransactionCategory.Accrual,
        PointsTransactionCategory.Refund,
        PointsTransactionCategory.WriteOffNegative,
      ];
      const sign = CATEGORIES_WITH_POSITIVE_AMOUNT.includes(category)
        ? '+'
        : '-';

      return `${sign}${this.pointsNumberService.roundNumber(
        pointsTransaction.amount,
        digitsInfo,
        roundDigits,
        roundMode,
      )}`;
    }
  }

  formatPointsBalance(
    pointsTransaction: PointsTransaction,
    digitsInfo: string = this.digitsInfo,
    roundDigits: number = 0,
    roundMode: RoundMode = RoundMode.NONE,
  ): string {
    const { balance } = pointsTransaction;

    return this.pointsNumberService.roundNumber(
      balance ?? 0,
      digitsInfo,
      roundDigits,
      roundMode,
    );
  }

  formatPointsStatementTransaction(
    amount: number,
    type: PointsStatementTransactionType,
    digitsInfo: string = this.digitsInfo,
    roundDigits: number = 0,
    roundMode: RoundMode = RoundMode.NONE,
  ): string {
    if (amount === 0) {
      return this.pointsNumberService.roundNumber(0, digitsInfo);
    } else {
      const sign = type === 'accrual' ? '+' : '-';

      return `${sign}${this.pointsNumberService.roundNumber(
        amount,
        digitsInfo,
        roundDigits,
        roundMode,
      )}`;
    }
  }
}
